import { DOMAIN as _ } from 'configs/constants/system'
export const STORE_ACCOUNT_STATUS = `${_} STORE_ACCOUNT_STATUS`
export const FETCH_ACCOUNT_STATUS = `${_} FETCH_ACCOUNT_STATUS`
export const SAVE_ACCOUNT_STATUS_SUCCESS = `${_} SAVE_ACCOUNT_STATUS_SUCCESS`
export const SAVE_ACCOUNT_STATUS_FAILED = `${_} SAVE_ACCOUNT_STATUS_FAILED`
